// extracted by mini-css-extract-plugin
export default {"wrapper":"Sd","form":"Td","label":"Ud","asterisk":"Vd","smallprint":"Wd","noMargin":"Xd","success":"Yd","circle":"Zd"};